var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7906 22.4882C34.0934 22.3307 34.3538 22.1026 34.5498 21.8232C35.9123 19.8808 30.3645 15.1707 29.9702 12.3398C28.9039 4.68327 22.8921 1.98047 16.1998 1.98047C7.18079 1.98047 1.98242 6.60547 1.98242 15.8555C1.98242 22.1816 3.63457 24.3015 5.63248 27.5342C6.72777 29.3065 7.1922 31.3774 7.18692 33.4608C7.18366 34.7416 7.18079 36.1182 7.18079 36.9798H23.0869V32.3725C23.2322 31.1955 24.2824 30.4036 25.4683 30.4036H26.7722C28.9616 30.4036 30.7364 28.6287 30.7364 26.4393V22.7803L32.8103 22.7282C33.1516 22.7281 33.4878 22.6457 33.7906 22.4882Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18079 35.0162C7.18079 34.5317 7.1817 34.0016 7.18307 33.4773C7.18856 31.3836 6.72508 29.3016 5.62397 27.5208C3.62988 24.2957 1.98242 22.173 1.98242 15.8558C1.98242 9.98454 4.07674 5.97663 7.91306 3.83203",
    stroke: "#9B2C51",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1836 13.2229V1.98047",
    stroke: "#9B2C51",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1842 23.7863C20.567 23.7863 22.4699 21.8834 22.4699 18.5006C22.4699 15.1177 20.567 13.2148 17.1842 13.2148C13.8013 13.2148 11.8984 15.1177 11.8984 18.5006C11.8984 21.8834 13.8013 23.7863 17.1842 23.7863Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1842 23.7863C20.567 23.7863 22.4699 21.8834 22.4699 18.5006C22.4699 15.1177 20.567 13.2148 17.1842 13.2148C13.8013 13.2148 11.8984 15.1177 11.8984 18.5006C11.8984 21.8834 13.8013 23.7863 17.1842 23.7863Z",
    stroke: "#9B2C51",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.6914C21.1429 26.3343 26.4286 29.07 33.0357 29.07",
    stroke: "#9B2C51",
    strokeWidth: 3.96429,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7382 22.7811L32.812 22.729C33.1533 22.7288 33.4895 22.6465 33.7923 22.489C34.0951 22.3314 34.3555 22.1033 34.5515 21.8239C35.914 19.8816 30.3662 15.1715 29.972 12.3406C29.3514 7.88461 27.0557 5.10648 23.9258 3.5625",
    stroke: "#9B2C51",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0859 35.0173C23.0859 34.3568 23.0859 34.3568 23.0859 33.6953",
    stroke: "#9B2C51",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.718f2caace02858420e9e9d0f25320fa.svg";
export { ForwardRef as ReactComponent };